/**
 * Repo-2 branding pass:
 * Keep CHG/Repo 2 visual tokens local to Smart Insights so the shared
 * application shell is not affected by this branding work.
 */
export const repo2Brand = {
  color: {
    burgundy: '#6E3450',
    burgundy50: '#f5e9ee',
    burgundy100: '#e7c8d2',
    burgundy700: '#5A2C58',
    burgundy900: '#3c1c39',
    teal: '#67ADCA',
    teal50: '#eef6fa',
    teal700: '#4E7C89',
    paper: '#FAF7F1',
    ivory: '#F5EFE6',
    ivory2: '#EDE5D8',
    border: '#EDE6E1',
    borderStrong: '#D9CFC4',
    gold: '#C9A24E',
    ink: '#1F1A20',
    inkSoft: '#3F3338',
    muted: '#7B6B72',
    mutedSoft: '#A8989F',
    positive: '#3F7D4F',
    negative: '#B23A48',
    plan: '#D4A038',
    info: '#3580B5',
  },
  shadow: {
    card: '0 1px 0 rgba(31,26,32,.04), 0 1px 3px rgba(31,26,32,.05)',
    cardLg: '0 4px 6px -1px rgba(31,26,32,.06), 0 12px 28px -10px rgba(110,52,80,.18)',
    float: '0 6px 12px rgba(31,26,32,.08), 0 24px 48px -12px rgba(110,52,80,.28)',
  },
  radius: {
    panel: '14px',
    control: '12px',
  },
} as const;

export const repo2FinanceV2ClassNames = {
  pageShell: 'finance-v2-repo2-theme bg-[#FAF7F1] text-[#1F1A20]',
  card: 'rounded-[14px] border border-[#EDE6E1] bg-white shadow-[0_1px_0_rgba(31,26,32,.04),0_1px_3px_rgba(31,26,32,.05)]',
  cardLg: 'rounded-[14px] border border-[#EDE6E1] bg-white shadow-[0_4px_6px_-1px_rgba(31,26,32,.06),0_12px_28px_-10px_rgba(110,52,80,.18)]',
  eyebrow: 'font-display text-[0.6875rem] font-semibold uppercase tracking-[0.12em] text-[#7B6B72]',
  iconButton: 'inline-flex h-9 w-9 items-center justify-center rounded-full text-[#7B6B72] transition-colors hover:bg-[#F5EFE6] hover:text-[#6E3450] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#6E3450]/30',
  primaryButton: 'inline-flex items-center justify-center rounded-[12px] bg-[#6E3450] px-4 py-2 text-sm font-semibold text-white shadow-[0_6px_12px_rgba(31,26,32,.08),0_24px_48px_-12px_rgba(110,52,80,.28)] transition-colors hover:bg-[#5A2C58] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#6E3450]/30',
  secondaryButton: 'inline-flex items-center justify-center rounded-[12px] border border-[#EDE6E1] bg-white px-4 py-2 text-sm font-semibold text-[#3F3338] transition-colors hover:bg-[#FAF7F1] hover:text-[#6E3450] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#6E3450]/20',
} as const;

export const financeV2HistoryPanelClassName =
  'finance-history-panel absolute right-4 top-[4.25rem] z-50 h-[min(34rem,calc(100vh-7rem))] w-[min(25rem,calc(100vw-2rem))] overflow-hidden rounded-[14px] border border-[#EDE6E1] bg-white shadow-[0_4px_6px_-1px_rgba(31,26,32,.06),0_12px_28px_-10px_rgba(110,52,80,.18)] sm:right-6';

/**
 * Repo-2 branding pass:
 * These overrides are intentionally scoped to the v2 history popover wrapper.
 * The shared ConversationSidebar is used by Smart Insights.
 */
export const financeV2HistoryPanelCss = `
  .finance-history-panel button[title="Start new conversation"] {
    display: none !important;
  }
  .finance-history-panel > div {
    height: 100%;
    background: #fbf8f4 !important;
    background-image: none !important;
    box-shadow: none !important;
    border-right: 0 !important;
    border-radius: 0 !important;
  }
  .finance-history-panel .sticky.top-0 {
    padding: 1rem 1.125rem 0.875rem 1.125rem !important;
    background: #ffffff !important;
    backdrop-filter: none !important;
  }
  .finance-history-panel .flex-1.overflow-y-auto {
    max-height: none !important;
  }
`;
